module.exports = __webpack_public_path__ + "static/img/nest-heating.e46ccdf.png";